'use strict';

/*
 * smooth scroll to anchor (view more)
 */
var ScrollTo = (function(){

    var triggerSelector = '[js-scrollto]';

    var triggerSelectorElements = document.querySelectorAll(triggerSelector);

    var applyTrigger = function(){

        for(var i = 0, length = triggerSelectorElements.length; i < length; i++){
            var element = triggerSelectorElements[i];
            element.addEventListener('click', function(e){
                e.preventDefault();

                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                var destinationElement = document.querySelector(this.getAttribute('href'));



                var alter = this.dataset && this.dataset.scrollto ?  parseInt(this.dataset.scrollto) : 0;

                var top = destinationElement.getBoundingClientRect().top + scrollTop + alter;

                scrollToY(top);
            });
        }
    };

    // easing equations from https://github.com/danro/easing-js/blob/master/easing.js
    let easingEquations = {
        easeOutSine: function (pos) {
            return Math.sin(pos * (Math.PI / 2));
        },
        easeInOutSine: function (pos) {
            return (-0.5 * (Math.cos(Math.PI * pos) - 1));
        },
        easeInOutQuint: function (pos) {
            if ((pos /= 0.5) < 1) {
                return 0.5 * Math.pow(pos, 5);
            }
            return 0.5 * (Math.pow((pos - 2), 5) + 2);
        }
    };


    let requestAnimFrame = function(callback){
        return  window.requestAnimationFrame(callback)       ||
            window.webkitRequestAnimationFrame(callback) ||
            window.mozRequestAnimationFrame(callback)    ||
            window.oRequestAnimationFrame(callback)      ||
            window.msRequestAnimationFrame(callback)     ||
            function( callback ){
                window.setTimeout(callback, 1000 / 60);
            };
    };

    // main function
    //http://stackoverflow.com/a/26798337
    function scrollToY(scrollTargetY, speed, easing) {
        var scrollY = window.scrollY,
            scrollTargetY = scrollTargetY || 0,
            speed = speed || 2000,
            easing = easing || 'easeOutSine',
            currentTime = 0;

        // min time .1, max time .8 seconds
        var time = Math.max(.1, Math.min(Math.abs(scrollY - scrollTargetY) / speed, .8));


        // add animation loop
        function tick() {
            currentTime += 1 / 60;


            var p = currentTime / time;
            var t = easingEquations[easing](p);

            if (p < 1) {
                requestAnimFrame(tick);

                window.scrollTo(0, scrollY + ((scrollTargetY - scrollY) * t));
            } else {
                window.scrollTo(0, scrollTargetY);
            }
        }

        // call it once to get started
        tick();
    }

    var setSelector = function(){
        triggerSelectorElements = document.querySelectorAll(triggerSelector);

        if(triggerSelectorElements.length){
            applyTrigger();
        }

    };

    var init = function(){

        setSelector();
    };

    return {
        init: init,
        setSelector: setSelector
    };

})();

export default ScrollTo;
